import { render, staticRenderFns } from "./ProjectDashboardNew.vue?vue&type=template&id=50d7e21a"
import script from "./ProjectDashboardNew.vue?vue&type=script&lang=js"
export * from "./ProjectDashboardNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports